export default __webpack_public_path__ + "media/images/hero-image-ee97b10322942a5a83f2d830624ac2d7.png";